import Vue from 'vue'
import { sync } from 'vuex-router-sync'

import App from './App.vue'
import './plugins/components'
import { SecurityInterceptor } from './plugins/interceptor'
import router from './router/index'
import store from './store/index'
import i18n from './i18n'
import axios from 'axios'

sync(store, router)

axios.defaults.baseURL = 'https://credits-api.applications-soutien.fr/'

let interceptor = new SecurityInterceptor({ store, router, i18n })
interceptor.attachRequestInterceptor()
interceptor.attachResponseInterceptor()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
